/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getSearchResults(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { urlService, sportId, types, userToken, query } = options;
        const requestUrl = urlService.getSearchQueryUrl({
            sportId,
            types: types === null || types === void 0 ? void 0 : types.join(','),
            userToken,
            query,
        });
        // Obtain data from back-end
        const fetchOptions = { signal: options.signal };
        const { data } = (yield fetch(requestUrl, fetchOptions).then((res) => res.json()));
        const items = data.hits
            .filter((item) => item.type !== 'helpanswer' || item.value.url) // Filter Help Answers without the URL, as these doesn't have a lot of context
            .filter((item) => item.type !== 'sport' || (item.value.name && item.value.slug)); // Filter out corrupted sport entries (mainly applies to manually added)
        // Return ready results
        return { items, categories: data.categories, queryIDs: data.queryIDs };
    });
}
//# sourceMappingURL=getSearchResults.js.map